import React, { useState, useEffect } from "react";
import Header from "../../Layouts/Header";
import Footer from "../../Layouts/Footer";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Breadcrumb from "../../Layouts/Breadcrumb";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import CircularProgress from "@material-ui/core/CircularProgress";
import AuthApi from "../../Services/Authapi";
import swal from "sweetalert";
import AuthCheckComponent from "../../Layouts/Token";
import { createSwalLoaderNode } from "../../Layouts/swalLoader";

const inivalue = {
  quli_id: 0,
  department: "",
};

const Departmentedit = (props) => {
  const classes = props;
  const [qulifi, setQulifi] = useState(inivalue);
  const [formErrors, setFormErrors] = useState({});
  const [submitLoading, setSubmitLoading] = useState(false);

  useEffect(() => {
    if (props && props.authToken === false) {
      // props.history.push("/login");
    }
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setQulifi({ ...qulifi, [name]: value });
  };

  const validate = (values) => {
    let errors = {};

    if (!values.department) {
      errors.department = "Department name cannot be blank";
    }

    return errors;
  };

  const Departmentshowbyid = async () => {
    let quliId =
      props.history.location.pathname.split("/")[props.history.location.pathname.split("/").length - 1];
    let get = await AuthApi.Departmentshowbyid1(quliId);
    let quli_id = quliId;
    if (get && get.data) {
      setQulifi({
        quli_id: quli_id,
        department: get.data.department,
      });
    } else {
      console.error("Failed to fetch department data:", get);
    }
  };

  useEffect(() => { setTimeout(() => Departmentshowbyid(), 500) }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (submitLoading) {
      return;
    }
    const errors = validate(qulifi);
    setFormErrors(errors);
    if (Object.keys(errors).length > 0) {
      return;
    }
    await Departmentupdate();
  };

  const Departmentupdate = async (id) => {
    setSubmitLoading(true);
    swal({
      title: "Loading",
      text: "Please wait...",
      buttons: false,
      closeOnClickOutside: false,
      closeOnEsc: false,
      width: "10%",
      content: createSwalLoaderNode()
    });
    try {
      let status = await AuthApi.Departmentupdate1(qulifi, qulifi.quli_id);
      swal.close();
      if (status && status.status === true) {
        swal("Success", "Department updated successfully", "success").then(() => {
          props.history.push("/Departmente");
        });
      } else {
        swal({
          title: "OOPS!",
          icon: "error",
          text: status && status.message ? status.message : "Something went wrong, Please try later!"
        });
      }
    } catch (error) {
      swal.close();
      console.error("Error updating qulification:", error);
      swal("Error", "An unexpected error occurred", "error");
    } finally {
      setSubmitLoading(false);
    }
  };

  return (
    <div>
      <AuthCheckComponent authToken={props.authToken} />
      <Header
        {...props}
        authUser={props.authUser}
        component={
          <div>
            <Card className={classes.root} style={{ marginBottom: "3%" }}>
              <CardContent>
                <Breadcrumb
                  {...props}
                  primaryPageName="Department"
                  primaryPageLink="/Departmente"
                  isSecondaryPage={true}
                  secondaryPageName="Edit"
                />
              </CardContent>
            </Card>
            <Grid container className={classes.root} spacing={2}>
              <Grid item xs={12}>
                <Card className={classes.root}>
                  <CardContent>
                    <Typography
                      variant="h2"
                      className="common-form-page-title"
                    >
                      Edit Department
                    </Typography>
                    <form className={`${classes.form} common-form-fields`} onSubmit={handleSubmit}>
                      <Grid container className={classes.root} spacing={5}>

                        <Grid item xs={6}>
                          <TextField
                            fullWidth
                            id="DepartmentName"
                            name="department"
                            label="Department"
                            variant="outlined"
                            error={formErrors.department && true}
                            value={qulifi.department || ""}
                            onChange={handleChange}
                          />
                          {formErrors.department && (
                            <span className="error">
                              {formErrors.department}
                            </span>
                          )}
                        </Grid>
                      </Grid>

                      <Grid container className={classes.root} spacing={3}>
                        <Grid item xs={4} style={{ display: "flex" }}>
                          <Button
                            type="submit"
                            style={{ marginTop: "10px", textTransform: 'capitalize' }}
                            variant="contained"
                            color="primary"
                            disabled={submitLoading}
                          >
                            {submitLoading ? <><CircularProgress size={18} style={{ marginRight: 8, color: 'inherit' }} /> Updating...</> : 'Edit'}
                          </Button>
                          <Button
                            type="button"
                            style={{ marginTop: "10px", textTransform: 'capitalize' }}
                            disabled={submitLoading}
                            onClick={(e) => {
                              e.preventDefault();
                              props.history.push("/Departmente");
                            }}
                          >
                            Cancel
                          </Button>
                        </Grid>
                        <Grid item xs={4}></Grid>
                        <Grid item xs={4}></Grid>
                      </Grid>
                    </form>
                  </CardContent>
                </Card>
              </Grid>
              <Grid item xs={6}></Grid>
            </Grid>
          </div>
        }
      />
      <Footer />
    </div>
  );
};

export default Departmentedit;
